import React from "react";
import classNames from "classnames";

const H2 = ({children, className, ...rest}) => {
    return <h2 className={classNames('ff-lora', className)} {...rest}>{children}</h2>
}

export default H2;
